export const PERFORMER_PROFILE_PATH = "/profile";

export const SOCIAL_MEDIA_POST_MESSAGE_AUTH_COMPLETE =
  "SOCIAL_MEDIA_POST_MESSAGE_AUTH_COMPLETE";

export const EDIT_PROFILE_ROUTE = "details";

export const CONTACTS_ROUTE = "contacts";

export const MY_HOME_PATH = "/myhome";

export const MY_HOME_ERROR_CODES_REDIRECTION = [400, 403, 404];
